import { DEFAULT_PAGE_SAZE } from '../../../common/PrimeTable/CustomPrimeTable'
import {
  CHANGE_EXPENSE_DATA,
  CHANGE_OPTIONS_DATA,
  CLEAR_EXPENSE_DATA,
  GET_ALL_EXPENSES,
  SET_LOADING,
} from './expenseTypes'

const initialState = {
  data: {
    data: [],
    query: {
      totalRecords: 0,
      limit: 5,
      first: 0,
    },
    total: 0,
  },
  options: {
    pagination: { limit: DEFAULT_PAGE_SAZE, first: 0 },
    sort: {},
    filter: {},
    tableFilter: {},
  },
  expense: {
    expense: 0,
    receiptUrl: '',
    receiptKey: '',
  },
  isLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case CLEAR_EXPENSE_DATA:
      return {
        ...state,
        expense: {
          expense: 0,
          receiptUrl: '',
          receiptKey: '',
        },
      }
    case CHANGE_EXPENSE_DATA:
      return {
        ...state,
        expense: {
          ...state.expense,
          [action.payload.name]: action.payload.value,
        },
      }
    case CHANGE_OPTIONS_DATA:
      return {
        ...state,
        options: action.payload,
      }
    case GET_ALL_EXPENSES:
      return {
        ...state,
        data: {
          data: action.payload.data,
          query: action.payload.query,
          total: action.payload.total,
        },
        isLoading: false,
      }
    default:
      return state
  }
}
